angular.module('SMART2').directive('smartInfotip', ['$window', function ($window) {
    "use strict";
    var _lastOpenInfotip = {},
    hideLastInfotip = function (hObj) {
        if (_lastOpenInfotip.target && _lastOpenInfotip.target.hasClass('isInfotipVisible')) {
            _lastOpenInfotip.target.removeClass('isInfotipVisible');
            _lastOpenInfotip.infotip.find(".infotip-popover").addClass('hide-popover-element');
            _lastOpenInfotip.infotip.find(".infotip-popover-triangle").addClass('hide-popover-element');
            _lastOpenInfotip._ev.value = true;
        }
    };
    $(document).click(function (evt) {
        hideLastInfotip();
     });
    return {
        restrict: 'A',
        transclude: true,
        scope:true,
        link: function (scope, element, attrs) {
            //the root div of the popup template
            var popover_container = element.find('.infotip-popover-container'),
                popover_container_parent = popover_container.parent(),
                popover = element.find('.infotip-popover'), //the popover element
                triangle = element.find('.infotip-popover-triangle'), //the small triangle attached with the popover
                triangle_height, //vertical height of the triangle
                triangle_diagonal, //base of the triangle
                triangle_div_side = 15, //side of the triangle
                triangle_rect_div_side = 30, //the div which has been rotated to make a triangle using the after pseudo class
                infotipElement = element,
                getPosition = popover_container_parent.css('position') === "" || popover_container_parent.css('position') === "static" ? "relative" : popover_container_parent.css('position'),
                $win = angular.element($window),
                bindOn = !attrs.bindOn ? 'click mouseover interesected' : attrs.bindOn;

            popover_container_parent.css({ 'position': getPosition, 'z-index': '1', 'display': 'inline-block' });
            //popover_container_parent.css('position', getPosition);
            //popover_container_parent.css('display', 'inline-block');
            triangle_height = Math.sqrt(triangle_div_side * triangle_div_side / 2);
            triangle_diagonal = Math.sqrt(triangle_div_side * triangle_div_side * 2);
            var mode = attrs.mode === '' || attrs.mode === undefined ? 'mouseover' : attrs.mode;
            var closeOnClick = attrs.closeOnClick === undefined ?
                                    (mode == 'click' ? true : false) :
                                    (attrs.closeOnClick === 'true');

            var closeOnMouseleave = attrs.closeOnMouseleave === undefined ?
                                        (mode == 'mouseover' ? true : false) :
                                        (attrs.closeOnMouseleave === 'true');

            var hideOnDocHover = { value: attrs.hideOnDocHover == 'true' };
            //return the path of the popover template
            scope.getContentPopover = attrs.templateUrl;

            scope.isTemplateUrl = attrs.templateUrl ? true : false;

            //depending upon the position specified, attached the appropriate class to the popover 
            var getTriangleClass = function () {
                return 'infotip-popover-triangle-' + attrs.position;
            }

            var hideTooltip = function () {
                setTimeout(function () {
                    if (!onHoverablearea() && hideOnDocHover.value) {
                        popover.addClass('hide-popover-element');
                        triangle.addClass('hide-popover-element');
                    }
                }, 0);
            };
            var onHoverablearea = function () {
                return (popover.is(':hover') || infotipElement.is(':hover') || triangle.is(':hover'));
            };

            scope.triangleClass = getTriangleClass();
            if (closeOnMouseleave) {
                if (hideOnDocHover.value) {
                    infotipElement.bind('mouseleave blur', function () {
                         hideTooltip();
                    });
                    popover.bind('mouseleave blur', function () {
                        hideTooltip();
                    });
                    triangle.bind('mouseleave blur', function () {
                        hideTooltip();
                    });
                }
                else {
                    infotipElement.bind('mouseleave blur', function () {
                        popover.addClass('hide-popover-element');
                        triangle.addClass('hide-popover-element');
                    });
                }
            }

            if (mode != 'click' && closeOnClick) {
                infotipElement.bind('click', function () {
                    popover.addClass('hide-popover-element');
                    triangle.addClass('hide-popover-element');
                });
            }

            popover.on('click', function (evt) {
                evt.stopPropagation();
            });

            //Hide infotip on scroll
            $win.bind('scroll', function (e) {
                popover.addClass('hide-popover-element');
                triangle.addClass('hide-popover-element');
            });

            //listen for click on the directive element
            infotipElement.bind(bindOn, function (evt) {
                evt.stopImmediatePropagation();
               var _this = $(this),
                parent_height = _this.outerHeight(),
                parent_width, popover_height, popover_width,
                elementOffsetTop = element.offset().top + 23,
                elementOffsetLeft = element.offset().left,
                leftPos;

                if (evt.type == "click") {
                    hideLastInfotip();
                    hideOnDocHover.value = false;
                    _this.addClass('isInfotipVisible');
                    _lastOpenInfotip.target = _this;
                    _lastOpenInfotip.infotip = popover_container;
                    _lastOpenInfotip._ev = hideOnDocHover;
                };

                if (mode == "canvas") {
                    elementOffsetTop = 100;
                    elementOffsetLeft = 100;
                    parent_height = 100;
                }

                //move the popover container to the bottom of the directive element
                popover_container.css("top", parent_height)//.style.top = parent_height + 'px';
                parent_width = _this.outerWidth();

                //'mouseover' mode
                if (popover.hasClass('hide-popover-element') && attrs.message != '') {
                    popover.removeClass('hide-popover-element');
                    triangle.removeClass('hide-popover-element');
                }

                //if the template is supplied instead of templateUrl, set the popover innerHTML to the string passed in the 'template' attribute
                if (attrs.message) {
                    var templateElement = _this.find('.infotip-popover-template');
                    templateElement.html(attrs.message);
                }

                var setDynamicInfotipPosition = function (position) {
                    _this.find('.' + scope.triangleClass).removeClass(scope.triangleClass);
                    triangle.removeClass(scope.triangleClass);
                    attrs.position = position;
                    scope.triangleClass = getTriangleClass();
                    triangle.addClass(scope.triangleClass);
                }

                attrs.position = attrs.position === '' || attrs.position === undefined ? 'top' : attrs.position;

                //function to set dynamic position for popover and triangle
                var getDyanamicPositions = function () {
                    var popoverOffset = popover.offset(),
                                        bodyScrolled = $("body").scrollTop() || $("html").scrollTop();

                    if (popoverOffset.left + popover.width() > $(window).width()) {
                        leftPos = true;
                        setDynamicInfotipPosition('left');
                    } else if (popoverOffset.left < (0 || 10)) {
                        setDynamicInfotipPosition('right');
                    } else if (popover[0].getBoundingClientRect().top < 0) {
                        setDynamicInfotipPosition('bottom');
                    } else if ((popover[0].getBoundingClientRect().top + popover.height()) >= $(window).height()) {
                        setDynamicInfotipPosition('top');
                    } 
                };

                //check position and calculate position for appending popover and triangle
                var setInfotipPosition = function () {
                    popover_height = popover.outerHeight();
                    popover_width = popover.outerWidth();

                    if (mode == "canvas") {
                        popover_height = 100;
                        popover_width = 100;
                        if (infotipElement.attr("interesect")) {
                            var intersect = JSON.parse(infotipElement.attr("interesect")),
                                templateElement;

                            popover.css({
                                top: (intersect.y - triangle_height - 100),
                                left: (intersect.x)
                            });
                            triangle.css({
                                top: (intersect.y - triangle_height - 100),
                                left: (intersect.x - triangle_rect_div_side)
                            });

                        }
                        templateElement = _this.find('.infotip-popover-template');
                        templateElement.html(infotipElement.attr("message"));
                        return;
                    }

                    switch (attrs.position) {
                        case 'top':
                            popover.css({
                                top: (-parent_height - popover_height - triangle_height),
                                left: ((parent_width - popover_width) / 2)
                            });
                            triangle.css({
                                top: (-parent_height - triangle_height),
                                left: ((parent_width - triangle_rect_div_side) / 2)
                            });
                            break;

                        case 'bottom':
                            popover.css({
                                top: triangle_height,
                                left: ((parent_width - popover_width) / 2)
                            });
                            triangle.css({
                                top: -(triangle_rect_div_side - triangle_height),
                                left: ((parent_width - triangle_rect_div_side) / 2)
                            });
                            break;

                        case 'right':
                            popover.css({
                                top: ((parent_height - popover_height) / 2 - parent_height),
                                left: parent_width + triangle_height
                            });
                            triangle.css({
                                top: ((parent_height - triangle_rect_div_side) / 2 - parent_height),
                                left: (parent_width - (triangle_rect_div_side - triangle_height))
                            });
                            break;

                        case 'left':
                            if (leftPos) {
                                popover.css({ left: -(popover_width + triangle_div_side) })
                            }
                            popover.css({
                                top: ((parent_height - popover_height) / 2 - parent_height),
                                right: triangle_height
                            });
                            triangle.css({
                                top: ((parent_height - triangle_rect_div_side) / 2 - parent_height),
                                left: -triangle_height
                            });
                            if (attrs.customStyle == 'true') {
                                popover.css({ left: -(popover_width + triangle_div_side - 5) });
                                triangle.css({
                                    top: ((parent_height - triangle_rect_div_side) / 2 - parent_height + 5),
                                });
                            }
                            break;
                    }
                }

                //Append infotip to body only when isFixed = 'true'
                var appendInfotipToBody = function () {
                    if (attrs.isFixed == 'true') {
                        if (!popover_container.data('appended')) {
                            angular.element('body').append(popover_container.data('appended', true));
                        }
                        if (attrs.customStyle == 'true') {
                            popover_container.addClass('fullWidthInfo');
                        }
                        if (attrs.showFullTip == 'true') {
                            popover_container.addClass('showFullTip');
                        }
                        var templateElementBody = popover_container.find('.infotip-popover-template');
                        templateElementBody.html(attrs.message);
                        popover_container.css({ 'top': elementOffsetTop + 'px', 'left': elementOffsetLeft + 'px', 'right': 'auto' });
                    }
                }

                setInfotipPosition();
                appendInfotipToBody();
                getDyanamicPositions();
                setInfotipPosition();
                appendInfotipToBody();
            });
        },
        templateUrl: 'shared/directives/uiElements/smartInfotip/smartInfotipTemplate.html'
    }
}]);